import statuses from '@/components/_modules/Invoices/cells/statuses'
import AttachmentsDetails from '@/components/_modules/Invoices/cells/attachments-details'
import { hideForCancelledOrRejected, customForCancelledOrRejected } from '@/components/_modules/Invoices/statuses'

export default {
  'InvoiceNumber': {
    label: 'Invoice',
    uid: 'Id',
    uri: '#/i/Invoices/sent/?goto=InvoiceDetail/{{id}}/0/send-invoices',
    onclick: 'setCookie("from_tab", "SentInvoices", "/")',
    width: 190
  },

  'ReferenceCode': {
    label: 'Supplier Invoice Number',
    width: 190,
    nowrap: false
  },

  'PONumber': {
    label: 'PO',
    width: 180
  },

  'EstimatedPaymentDateFormatted': {
    label: 'Estimated Payment Date',
    getter: customForCancelledOrRejected,
    nowrap: false
  },

  'PaymentStatus': {
    label: 'Invoice Status',
    source: 'PaymentInvoiceList_ReceivedInvoices',
    render: statuses,
    width: 300
  },

  'ClientName': {
    label: 'Client',
    uid: 'PoSenderVci',
    uri: '#/i/Invoices/Profile{{id}}-{{screen}}',
    tooltip: 'View profile of {{text}}'
  },

  'ProgramName': 'Project',

  'TotalAmount': {
    label: 'Amount',
    getter: hideForCancelledOrRejected
  },

  'DueDateWithinFormatted': {
    label: 'Due',
    getter: hideForCancelledOrRejected
  },
  'DueDateWithin': '_',

  'MediaCount': {
    label: 'Attachments',
    detailsCondition: showAttachmentsExpandIcon,
    details: 'invoice.getAttachmentsDetails',
    detailsParamsURL: getAttachmentsDetailsParams,
    detailsComp: AttachmentsDetails,
    visible: false
  },
  'CreatedBy': {
    label: 'Created By',
    visible: false
  },
  'CreatedByName': {
    label: 'Created By Name',
    visible: false
  },
  'EventName': {
    label: 'Event',
    visible: false
  },
  'FirstEventEndDateFormatted': {
    label: 'Event End Date',
    visible: false
  },
  'FirstEventStartDateFormatted': {
    label: 'Event Start Date',
    visible: false
  },
  'InvoiceDateFormatted': {
    label: 'Invoice Date',
    visible: false
  },
  'RemittanceInvoiceFormatted': {
    label: 'Payment Remittance Invoice',
    compose: remittanceInvoice,
    visible: false
  },
  'ProgramEndDateFormatted': {
    label: 'Project End Date',
    visible: false
  },
  'ProgramStartDateFormatted': {
    label: 'Project Start Date',
    visible: false
  },
  'ReqCode': {
    label: 'SAP PO',
    visible: false
  },
  'SupplierIDCode': {
    label: 'Supplier ID',
    visible: false
  }
}

function remittanceInvoice(p) {
  if (!p.data) return ''

  const url = `${global.app.api.env}/ProgramFusion/GenerateFundingInvoicePdf/${p.value}?fundingInvoiceID=${p.data.RemittanceInvoiceID}`
  let formattedValue = ''

  p.data.IsCreditInvoice
    ? p.data.RemittanceInvoiceCount === 1
      ? formattedValue = `<a href=${url} target="_blank" data-action="goto">${p.value}</a>`
      : p.data.RemittanceInvoiceCount > 1
        ? p.value
        : null
    : null

  return formattedValue
}

function showAttachmentsExpandIcon(params) {
  return params.data.MediaCount > 0
}

function getAttachmentsDetailsParams(params) {
  return `/${params.data.PaymentInvoiceID}?` +
    `&poId=${params.data.POID}` +
    `&poVersionId=${params.data.POVersionID}` +
    `&poType=${params.data.POType}` +
    `&programid=${params.data.ProgramID}`
}



// WEBPACK FOOTER //
// ./src/components/_modules/Programs/Invoice-sent/model.js